
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { 
    query,
    getDocs,
    collection,
    where,
    doc,
    updateDoc      
} from "firebase/firestore";

//
import { db } from '../../Firebase'

// states
import { setUser } from './../../redux/userSlice';
import { setgtMessage } from './../../redux/gtmsgSlice';
import { gtSuccess, gtError, setgtNull, gtNeutral } from './../../redux/gtstatusSlice';
import { startLoading, stopLoading } from './../../redux/loadingSlice';






export const useDeletedata = () => {

    const user = useSelector((state) => state.user.value)

    const dispatch = useDispatch()


    const deleteData = async (connectItem) => {
        try {
            if(user) {
                dispatch(startLoading())
                console.log(user.username)
                const now = new Date().getTime()
                
                // query user docs to update
                const userquery = query(collection(db, "usersdetails"), where("username", "==", user.username))
                // execute the query
                const userquerySnapshot = await getDocs(userquery);
    
                if (!userquerySnapshot.empty) {
                    // get the first matching document (assuming usernames are unique)
                    const userDoc = userquerySnapshot.docs[0];
                    const userDocRef = doc(db, "usersdetails", userDoc.id);
    
                    const updatedData = { 
                        all_scores: [], 
                        connectionsChats: {therapy: [], instructor: [], coach: []},
                        current_diff: {stldiff: 0, sqdiff: 0, what_day: 0, mtdiff: 0, phydiff: 0},
                        connections: [], 
                        lastActivity: now,
                        current_scores: {
                            selfCareScore: 0, stressLevelScore: 0, stressReductionScore: 0, physicalHealthScore: 0, depressionSupportScore: 0, anxietyManagementScore: 0, 
                            mentalStateScore: 0, dailyWellnessScore: 0, sleepQualityScore: 0, moodLevelScore: 0,
                        },
                        mood_logs: [],
                        physical_info: null,
                        recentConversations: [],
                        schedules: [],
                        weekly_score_details: {
                            personalizedCopingStrategies: {suggestions: [], message: ''},
                            therapySuggestions: {suggestions: [], message: ''},
                            lifestyleAdjustments: {suggestions: [], message: ''},
                            thursday: 0,
                            friday: 0,
                            monday: 0,
                            tuesday: 0,
                            wednesday: 0,
                            saturday: 0,
                            sunday: 0,
                        }
                    }
        
                    // Update the document with the new data
                    await updateDoc(userDocRef, updatedData);
    
                    // update states
                    var itemUpdate = { ...user, ...updatedData }
                    dispatch(setUser(itemUpdate))
                    dispatch(gtNeutral())
                    dispatch(setgtMessage(`data deleted`))
                    console.log(`data deleted`);
                    dispatch(stopLoading())
                } else {
                    dispatch(gtError())
                    dispatch(setgtMessage(`no user found with username "${user.username}".`))
                    console.log(`no user found with username "${user.username}".`);
                    dispatch(stopLoading())
                }
            } else {
                dispatch(gtError())
                dispatch(setgtMessage(`user is null, refresh or login again.`))
                console.log(`user state is null`);
            }

        } catch (err) {
            console.log('try catch err: ', err.message)
            dispatch(gtError())
            dispatch(setgtMessage(`${err.message}, try to refresh the page`))
            dispatch(stopLoading())
        }
    }



    return { deleteData }
}



